module.exports = __webpack_public_path__ + "static/media/walmart-logo.6baf3a7b.png";